import React, { Component } from "react";
import BGUrl from "../../assets/img/bg-paper-lite.jpg";
import LBawahURL from "../../assets/img/lengkungbawah.png";
import LAtasURL from "../../assets/img/lengkungatas.png";
// get our fontawesome imports
import { faCheckSquare, faCaretDown } from "@fortawesome/free-solid-svg-icons";
import { faEnvelope } from "@fortawesome/free-regular-svg-icons";
import { faInstagram, faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import LazyLoad from "react-lazyload";
import AOS from "aos";

class LPSection1 extends Component {
  constructor() {
    super();
    this.state = {
      kalangan: [
        "Program pemerintah",
        "Produk artis",
        "Perusahaan",
        "UKM",
        "Dan masih banyak lagi di seluruh indonesia dan international",
      ],
      bidusaha: [
        "Social",
        "Environment",
        "Education",
        "Health",
        "Industri",
        "Food & Beverage",
        "Fashion",
        "IT",
        "Services",
        "Automotive",
        "Cosmetics",
        "Finance",
      ],
      alasan: [
        "<b>MENINGKATKAN PENJUALAN</b> PERUSAHAAN MELALUI INSTAGRAM BISNIS",
        "MEMBANTU MENGOPTIMASI INSTAGRAM SUPAYA LEBIH <b>DIKENAL DAN TERLIHAT MENARIK</b>",
        "<b>LEBIH HEMAT</b> KARENA TIDAK PERLU REKRUT KARYAWAN DESIGN DAN ADMIN INSTAGRAM",
        "COCOK SEKALI BUAT ONLINE SHOP, YANG SANGAT PENTING SEKALI UNTUK <b>KONTEN DAN DESAIN YANG BAGUS</b>",
        "DENGAN KONTEN YANG BAGUS DAN MENARIK DAPAT MEMBUAT ORANG <b>LEBIH SUKA BERINTERAKSI</b>",
        "KONTEN DENGAN DESIGN DAN CAPTION YANG MENARIK DAN <b>SESUAI DENGAN TARGET MARKET</b>",
      ],
      perhitungan: [
        "Mari Perhitungkan !!!",
        "Yang pertama setiap karyawan akan dikenakan upah UMR yang minimal 3 jutaan. Untuk mengelola Instagram akan butuh designer dan pengelola Instagram total pengeluaran untuk 2 karyawan saja sudah 6 jutaan, dengan jasa kami bisa hemat sampai 90%.",
        "Belum lagi akan membutuhkan model untuk endorse yang semakin hari makin besar biayanya minimal ratusan ribu dan susah untuk atur waktunya.",
        "Yang ketiga butuh waktu lama dan memerlukan biaya yang cukup banyak untuk belajar desain (minimal 1 juta perbulan), belajar foto (minimal 900 ribu perkelas), iklan untuk cari followers (minimal 10 juta perbulan). Upload setiap hari (bahkan banyak orang tidak konsisten untuk upload) padahal itu yang bisa membuat Instagram kita selalu dilihat orang atau calon customer, yakin? mau belajar terus, eksekusinya kapan?",
        "Ke empat, susah mencari konsep karena kurangnya bahan upload dan selalu memikirkan konsep akhirnya lupa upload dan ngerasa jualan online tidak efektif.",
      ],
      didapat: [
        {
          title: "UPLOAD FEED SETIAP HARI",
          content: "Konsep bisa dari customer atau tim kami",
          badge: false,
        },
        {
          title: "UPLOAD STORY SETIAP HARI",
          content: "Konsep bisa dari customer atau tim kami",
          badge: false,
        },
        {
          title: "DIBUATKAN CAPTION/COPYWRITING",
          content: "Konsep bisa dari customer atau tim kami",
          badge: false,
        },
        {
          title: "DIBUATKAN HASHTAG BERTARGET",
          content: "Konsep bisa dari customer atau tim kami",
          badge: false,
        },
        {
          title: "DIBUATKAN LINK WA/LINK TREE",
          content: "Konsep bisa dari customer atau tim kami",
          badge: false,
        },
        {
          title: "DESAIN LOGO",
          content: "Konsep bisa dari customer atau tim kami",
          badge: false,
        },
        {
          title: "DESAIN COVER SOROTAN",
          content: "Konsep bisa dari customer atau tim kami",
          badge: false,
        },
        {
          title: "DESAIN FEED",
          content: "Konsep bisa dari customer atau tim kami",
          badge: false,
        },
        {
          title: "DESAIN STORY",
          content: "Konsep bisa dari customer atau tim kami",
          badge: false,
        },
        {
          title: "KONSEP IDE KONTEN",
          content: "Konsep bisa dari customer atau tim kami",
          badge: false,
        },
        {
          title: "BONUS DESAIN FOTO PRODUK",
          content: "Konsep bisa dari customer atau tim kami",
          badge: true,
        },
        {
          title: "BONUS ENDORSE SELEBGRAM",
          content: "Konsep bisa dari customer atau tim kami",
          badge: true,
        },
        {
          title: "BONUS 100 FOLLOWERS",
          content: "Konsep bisa dari customer atau tim kami",
          badge: true,
        },
      ],
      portofolio: [
        "tekun.id",
        "autokaya.id",
        "Bejaon",
        "Doyan Ayam",
        "doortodoor.carwash",
        "Smobile Jepang",
      ],
      msg: null,
      type: null,
      flash: false,
      alert: null,
    };
  }

  badgeHTML(cond) {
    if (cond) {
      return <span className="badge bg-yellow text-dark">HARI INI</span>;
    }
  }

  lazyLoadSetting() {
    new LazyLoad({
      callback_load: function () {
        AOS.refresh();
      },
    });
  }

  render() {
    const styles1 = {
      width: "200px",
    };
    const { kalangan, bidusaha, alasan, perhitungan, didapat, portofolio } =
      this.state;
    return (
      <div className="main-bg" style={{ backgroundImage: `url(${BGUrl})` }}>
        <div className="container-fluid overflow-hidden">
          {/* SECTION 1 */}
          <div className="container mt-6 mb-5 py-3">
            <div className="row">
              <div className="col-12 col-sm-8">
                <div data-aos="fade-right">
                  <h1 className="fw-bolder display-4 text-red">
                    BANTU{" "}
                    <span className="cf-hl-yellow text-black px-2">
                      MENINGKATKAN
                    </span>{" "}
                    PERFORMA ONLINE SHOP DAN MEMBERIKAN{" "}
                    <span className="cf-hl-yellow text-black px-2">HASIL</span>{" "}
                    YANG LEBIH BAIK DENGAN{" "}
                    <span className="cf-hl-yellow text-black px-2">
                      SANGAT MUDAH
                    </span>
                  </h1>
                </div>
                <div data-aos="fade-up">
                  <p className="text-red fw-bold fs-4 mt-5">
                    Desain profesional untuk menunjang promosi bisnis agar
                    semakin melejit. Layanan kami juga membantu anda dalam
                    membuat konten kreatif, caption hingga membantu
                    mengoptimalkan sosial media bisnismu. Penasaran? silakan
                    hubungi dibawah ini
                  </p>
                </div>
                <div className="mt-5">
                  <div data-aos="fade-up">
                    <a
                      href="https://api.whatsapp.com/send?phone=628974525222&text=Halo%20kak!%20Saya%20tertarik%20untuk%20konsultasi%20sosial%20media%20manajemen%20di%20Creatifa%20Studio%20%0A%0ANama%20Saya%20%3A%0ABisnis%20Saya%20%3A%0ABergerak%20di%20Bidang%20%3A%0ALokasi%20%3A%0AWebsite%20%2F%20Sosmed%20Bisnis%20Saya%20%3A%0AEmail%20Saya%20%3A"
                      target="_blank"
                      rel="noreferrer"
                      type="button"
                      className="btn btn-red px-4 fs-3 shadow text-decoration-none"
                    >
                      Hubungi Kami
                    </a>
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-4">
                <div data-aos="fade-left">
                  <LazyLoad height={200}>
                    <img
                      src="/img/objek-orang.png"
                      className="img-fluid trans-v1 mt-3 mt-sm-5"
                      alt="ilustrasi"
                    />
                  </LazyLoad>
                </div>
              </div>
            </div>
          </div>

          {/* SECTION 2 */}
          <div className="container mt-6-v2 mb-5 py-3">
            <div className="row">
              <div data-aos="fade-up">
                <h1 className="fw-bolder display-4 text-red text-center font-nunito">
                  <span className="cf-hl-yellow px-2">PENTING!!</span>
                </h1>
              </div>
            </div>

            <div className="row col-12 col-sm-9">
              <div data-aos="fade-right">
                <h1 className="fw-bold text-black mt-5">
                  KARENA MAU TIDAK MAU SEMUA HARUS BISNIS{" "}
                  <span className="text-red">BY ONLINE</span> DI TENGAH KONDISI
                  SAAT INI DAN JUTAAN ORANG TELAH BISNIS LEWAT{" "}
                  <span className="text-red">INSTAGRAM</span>
                </h1>
              </div>
            </div>

            <div className="row">
              <div className="col-12 col-sm-7">
                <div data-aos="fade-up">
                  <ul className="list-unstyled">
                    <li>
                      <p className="text-black fw-bold fs-4 mt-5">
                        Creatifa Studio mulai dari tahun 2020 telah menangani
                        desain dari berbagai kalangan seperti :
                      </p>
                      <ul className="text-black fw-bold fs-5 lst-none">
                        {kalangan.map((kal, i) => (
                          <li key={i}>
                            <FontAwesomeIcon
                              icon={faCheckSquare}
                              className="me-3 text-red"
                            />
                            {kal}
                          </li>
                        ))}
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-12 col-sm-5">
                <div data-aos="fade-left">
                  <LazyLoad height={200}>
                    <img
                      src="/img/monitor1.png"
                      className="img-fluid scale-08"
                      alt="ilustrasi"
                    />
                  </LazyLoad>
                </div>
              </div>
            </div>

            <div className="row mt-4">
              <div className="col-12 col-sm-7">
                <div data-aos="fade-up">
                  <ul className="list-unstyled">
                    <li>
                      <p className="text-black fw-bold fs-4 mt-5">
                        Dengan berbagai bidang usaha:
                      </p>
                      <ul className="text-black fw-bold fs-5 lst-none">
                        {bidusaha.map((bid, i) => (
                          <li key={i}>
                            <FontAwesomeIcon
                              icon={faCheckSquare}
                              className="me-3 text-red"
                            />
                            {bid}
                          </li>
                        ))}
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-12 col-sm-5 pe-5">
                <div data-aos="fade-left">
                  <LazyLoad height={200}>
                    <img
                      src="/img/globe1.png"
                      className="img-fluid trans-y-30"
                      alt="ilustrasi"
                    />
                  </LazyLoad>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container-fluid bg-yellow overflow-hidden mt-5">
          <div className="container mt-6 mb-5 py-3">
            <div data-aos="fade-up">
              <h1 className="fw-bold text-red text-center">
                KENAPA MEMILIH JASA KELOLA KAMI?
              </h1>
            </div>

            <div className="row row-cols-1 row-cols-md-2 g-5 my-5">
              {alasan.map((ala, i) => (
                <div className="col" key={i}>
                  <div data-aos="fade-up">
                    <div className="card h-100 mx-2 mx-sm-5 my-3 pt-3 px-4 text-center shadow">
                      <LazyLoad height={200}>
                        <img
                          src={`/img/icon` + (i + 1) + `.png`}
                          className="text-center"
                          alt={`icon` + 1}
                        />
                      </LazyLoad>
                      <div className="card-body">
                        <h5 className="card-title">
                          <div dangerouslySetInnerHTML={{ __html: ala }} />
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="container-fluid overflow-hidden">
          <div className="container mt-6 mb-5 py-3 text-center">
            <div data-aos="fade-up">
              <h1 className="text-center font-nunito text-red font-weight-bolder display-4">
                Hemat Sampai Jutaan Rupiah
              </h1>
            </div>

            <div data-aos="fade-up">
              <div className="fw-bold">
                {perhitungan.map((per, i) => (
                  <p className="text-black fs-4 my-4" key={i}>
                    {per}
                  </p>
                ))}

                <p className="col-12 col-sm-7 mx-auto fs-2 text-red my-4">
                  Total Biaya di atas adalah 18 juta perbulan dan waktu belajar
                  yang lama
                </p>

                <p className="mx-auto fs-2 text-black my-4">
                  Di Creatifa kamu akan{" "}
                  <span className="cf-hl-yellow px-2 text-red">Hemat 98%</span>{" "}
                  dari total biaya di atas !!!
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="container-fluid bg-red overflow-hidden">
          <div className="container mt-6 mb-5 py-3">
            <div data-aos="fade-right">
              <h1 className="text-white fw-bold display-4">
                Kami telah lama berkecimpung di dunia instagram dan
                bertahun-tahun pengalaman membuat konten di instagram hingga
                memiliki lebih dari 60 ribu followers
              </h1>

              <a
                href="https://api.whatsapp.com/send?phone=628974525222&text=Halo%20kak!%20Saya%20tertarik%20untuk%20konsultasi%20sosial%20media%20manajemen%20di%20Creatifa%20Studio%20%0A%0ANama%20Saya%20%3A%0ABisnis%20Saya%20%3A%0ABergerak%20di%20Bidang%20%3A%0ALokasi%20%3A%0AWebsite%20%2F%20Sosmed%20Bisnis%20Saya%20%3A%0AEmail%20Saya%20%3A"
                target="_blank"
                rel="noreferrer"
                type="button"
                className="btn btn-white text-red px-4 fw-bold fs-3 shadow mt-5 position-relative z-index-100"
              >
                PESAN SEKARANG
              </a>
            </div>
          </div>
          <div data-aos="fade-left">
            <LazyLoad height={200}>
              <img
                src="/img/meja-laptop1.png"
                className="img-fluid float-end trans-x-10 mt-7-v2"
                alt="meja dan laptop"
              ></img>
            </LazyLoad>
          </div>
        </div>

        <div className="container-fluid overflow-hidden">
          <div className="container mt-6 mb-5 py-3">
            <div data-aos="fade-up">
              <h1 className="col-12 col-sm-9 mx-auto text-center font-weight-bolder text-black">
                Apa saja yang akan anda dapatkan apabila menggunakan Paket
                Social Media Management dari Creatifa Studio?
              </h1>
            </div>
            <div className="row col-12 col-sm-8 mt-5 mx-auto">
              <div data-aos="fade-up">
                <div className="d-grid gap-4">
                  {didapat.map((dpt, i) => (
                    <button
                      className="btn btn-dark fs-6 fs-sm-4 py-3 px-4-5 rounded-4 trans-all btn-hover text-start shadow"
                      type="button"
                      id={`collapseBox` + (i + 1)}
                      data-bs-toggle="collapse"
                      data-bs-target={`#collapseExample` + (i + 1)}
                      key={i}
                    >
                      <div className="d-flex justify-content-between">
                        <div>
                          {dpt.title} {this.badgeHTML(dpt.badge)}
                        </div>
                        <FontAwesomeIcon
                          icon={faCaretDown}
                          className="text-center fa-fw fs-6 fs-sm-4 text-end"
                        />
                      </div>
                      <div
                        className="collapse"
                        id={`collapseExample` + (i + 1)}
                      >
                        <div className="card-body fs-5">{dpt.content}</div>
                      </div>
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container-fluid bg-red overflow-hidden">
          <div className="container mt-5 mb-5 py-3">
            <div className="row mx-auto col-12 col-sm-8">
              <div data-aos="fade-up">
                <h1 className="fw-bold text-center text-white">
                  Berikut beberapa klien dan desain yang pernah kami kerjakan
                </h1>
              </div>
            </div>
            <div className="row row-cols-1 row-cols-md-3 g-5 mt-4">
              {portofolio.map((porto, i) => (
                <div className="col" key={i}>
                  <div data-aos="fade-up">
                    <div className="card mx-2 my-3 pt-2 px-4 bg-transparent border-0">
                      <LazyLoad height={200}>
                        <img
                          src={`/img/smm` + (i + 1) + `.png`}
                          className="img-fluid"
                          alt={porto}
                        />
                      </LazyLoad>
                      <div className="card-body">
                        <h5 className="card-title fw-bold text-center text-yellow">
                          {porto}
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className="row mx-auto mt-5">
              <div data-aos="fade-up">
                <h2 className="fw-bold text-center text-white">
                  dan masih banyak lagi desain yang kami buat
                </h2>
              </div>
            </div>
          </div>
        </div>

        <div
          className="container-fluid overflow-hidden lengkung-bawah"
          style={{ backgroundImage: `url(${LBawahURL})` }}
        >
          <div className="container mt-5 mb-5 py-3">
            <div data-aos="fade-up">
              <h1 className="text-center font-weight-bolder text-black">
                Berikut beberapa testimoni dari klien kami
              </h1>
            </div>
            <div className="row row-cols-1 row-cols-md-2 g-5 mt-4">
              <div className="col">
                <div className="row row-cols-1">
                  <div data-aos="fade-right">
                    <div className="card text-center mx-2 my-3 pt-2 bg-transparent border-0">
                      <LazyLoad height={200}>
                        <img
                          src="/img/cutshd1.png"
                          className="img-com"
                          alt="Logo Cuts"
                        />
                      </LazyLoad>
                      <div className="card-body">
                        <h5 className="card-title fw-bold text-center text-black mt-4">
                          CUT SALSABILA BAHROEM
                          <br />
                          <span className="fw-normal">Owner Cuts Company</span>
                        </h5>
                        <p className="card-text mx-auto text-justify my-3 col-12 col-sm-7">
                          Saya puas sekali menggunakan jasa Creatifa Studio
                          dalam pengembangan usaha saya, saya berharap semoga
                          kedepannya bisa bekerja sama lagi dengan Creatifa
                          Studio. Saya tidak punya kritik dan saran dalam hal
                          ini, karena saya tau Creatifa sudah sangat baik dalam
                          pelayanan jasa designnya.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div data-aos="fade-right">
                    <div className="card text-center mx-2 my-3 pt-2 bg-transparent border-0">
                      <LazyLoad height={200}>
                        <img
                          src="/img/optimalhd1.png"
                          className="mx-auto img-com"
                          alt="Logo Cuts"
                        />
                      </LazyLoad>
                      <div className="card-body">
                        <h5 className="card-title fw-bold text-center text-black mt-4">
                          SAIF AKMAL
                          <br />
                          <span className="fw-normal">
                            Owner Optimal Kacamata
                          </span>
                        </h5>
                        <p className="card-text mx-auto text-justify my-3 col-12 col-sm-7">
                          Creatifa memberikan desain unik dan menarik bagi
                          kliennya. Perhatian pada branding toko sangat OKE dan
                          LENGKAP. HASILNYA BAGUS DAN TIDAK MENGECEWAKAN.
                          Terimakasih banya Creatifa.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div data-aos="fade-right">
                    <div className="card text-center mx-2 my-3 pt-2 bg-transparent border-0">
                      <LazyLoad height={200}>
                        <img
                          src="/img/sannpramahd1.png"
                          className="mx-auto img-com"
                          alt="Logo Cuts"
                        />
                      </LazyLoad>
                      <div className="card-body">
                        <h5 className="card-title fw-bold text-center text-black mt-4">
                          RENO SYAFRUDIN
                          <br />
                          <span className="fw-normal">
                            Owner Sannprama
                            <br />
                            (PT. Pratama Semesta Propertindo)
                          </span>
                        </h5>
                        <p className="card-text mx-auto text-justify my-3 col-12 col-sm-7">
                          Terima kasih buat Creatifa Studio yang sudah mampu
                          memberikan solusi untuk pembuatan logo di perusahaan
                          saya, setelah 2x meeting dan konsultasi di Whatsapp,
                          alhamdulillah logonya sesuai dengan yang diharapkan
                          dan juga waktu pengerjaannya yang terbilang
                          cepat.Sukses terus buat Creatifa Studio.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col">
                <div className="row row-cols-1">
                  <div data-aos="fade-left">
                    <div className="card text-center mx-2 my-3 pt-2 bg-transparent border-0">
                      <LazyLoad height={200}>
                        <img
                          src="/img/luxushd1.png"
                          className="mx-auto img-com"
                          alt="Logo Cuts"
                        />
                      </LazyLoad>
                      <div className="card-body">
                        <h5 className="card-title fw-bold text-center text-black mt-4">
                          FALIH RIZQULLAH W.
                          <br />
                          <span className="fw-normal">Owner LUXUS</span>
                        </h5>
                        <p className="card-text mx-auto text-justify my-3 col-12 col-sm-7">
                          Baru kali ini ngerasain design studio yang bisa brief
                          dengan video conference juga, jadi ide bisa langsung
                          disampaikan ke designer nya.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div data-aos="fade-left">
                  <div className="row row-cols-1">
                    <div className="card text-center mx-2 my-3 pt-2 bg-transparent border-0">
                      <LazyLoad height={200}>
                        <img
                          src="/img/mundihd1.png"
                          className="mx-auto img-com"
                          alt="Logo Cuts"
                        />
                      </LazyLoad>
                      <div className="card-body">
                        <h5 className="card-title fw-bold text-center text-black mt-4">
                          ULIANSYAF
                          <br />
                          <span className="fw-normal">
                            Owner PT.Mundi Teknik Eternindo
                          </span>
                        </h5>
                        <p className="card-text mx-auto text-justify my-3 col-12 col-sm-7">
                          Saya sangat puas dengan pelayanan yang diberikan oleh
                          Creatifa Studio. Dalam mendesain logo sesuai dengan
                          saya inginkan, Creatifa terlebih dahulu melakukan
                          survey mendalam terhadap perusahaan, produk, target
                          market, kompetitor, tipe desain yang diinginkan, warna
                          logo, dll dengan mengisi form pertanyaan di awal. Ini
                          yang menurut saya adalah kelebihan yang dimiliki oleh
                          Creatifa dan menjadi daya tarik tersendiri bagi saya
                          dan mungkin bagi customer lainnya. Dalam proses
                          desain, Creatifa juga mengedepankan komunikasi dua
                          arah yang baik dan memberikan ide/saran terbaik kepada
                          customer dan selalu menjawab pertanyaan secara
                          professional.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="container-fluid overflow-hidden lengkung-atas"
          style={{ backgroundImage: `url(${LAtasURL})` }}
        >
          <div className="container mt-6 mb-5 py-3">
            <div data-aos="fade-up">
              <h1 className="fw-bold text-center text-black">KLIEN KAMI</h1>
            </div>
            <div data-aos="fade-up">
              <div className="row col-12 col-sm-8 mx-auto mt-6 flex-column">
                <LazyLoad height={200}>
                  <img
                    src="./img/daftarklien.png"
                    className="img-fluid text-center"
                    alt="klien kami"
                  />
                </LazyLoad>
              </div>
            </div>
            <div data-aos="fade-up">
              <h2 className="fw-bold text-center mt-6 text-black">
                dan masih banyak lagi...
              </h2>
            </div>

            <div data-aos="fade-up">
              <div className="row mt-6 col-8 col-sm-2 mx-auto">
                <div className="badge py-3 bg-red fs-4">Henry Ford</div>
              </div>
              <div className="row mt-4 mx-auto col-12 col-sm-7">
                <h2 className="text-red text-center font-weight-bolder">
                  “Kegagalan hanyalah kesempatan untuk memulai lagi, kali ini
                  lebih cerdas”
                </h2>
                <br />
                <span className="text-center text-red fw-bold fs-5">
                  -Henry Ford, Pendiri Ford Motor Company-
                </span>
              </div>
            </div>

            <div data-aos="fade-up">
              <div className="row mt-6 mx-auto text-center flex-column">
                <h2 className="text-black text-center font-weight-bolder">
                  <span className="cf-hl-yellow px-2">Kenapa Creatifa?</span>
                </h2>
                <LazyLoad height={200}>
                  <img
                    src="/img/whycreatifa.png"
                    className="mt-4 mt-sm-5 col-12 col-sm-5"
                    alt="kenapa creatifa"
                  />
                </LazyLoad>
              </div>
            </div>

            <div className="row mt-6 mx-auto">
              <div data-aos="fade-up">
                <div className="col-12 col-sm-9 bg-red p-4 mx-auto">
                  <h2 className="text-light text-center fw-bold">
                    KAMI ADALAH STUDIO DESAIN & BRANDING PERTAMA DAN
                    SATU-SATUNYA DI INDONESIA YANG BERANI MEMBERIKAN TRIPLE
                    GARANSI INI
                  </h2>
                </div>
              </div>
              <div className="row mx-auto row-cols-1 row-cols-md-3 g-5 mt-4">
                <div className="col">
                  <div data-aos="fade-up">
                    <LazyLoad height={200}>
                      <img
                        src="/img/garansi1.png"
                        className="img-fluid"
                        alt="garansi"
                      />
                    </LazyLoad>
                  </div>
                </div>
                <div className="col">
                  <div data-aos="fade-up">
                    <LazyLoad height={200}>
                      <img
                        src="/img/garansi2.png"
                        className="img-fluid"
                        alt="garansi"
                      />
                    </LazyLoad>
                  </div>
                </div>
                <div className="col">
                  <div data-aos="fade-up">
                    <LazyLoad height={200}>
                      <img
                        src="/img/garansi3.png"
                        className="img-fluid"
                        alt="garansi"
                      />
                    </LazyLoad>
                  </div>
                </div>
              </div>
            </div>

            <div className="row col-10 col-sm-4 mt-6 mx-auto text-center">
              <div data-aos="fade-up">
                <a
                  href="https://api.whatsapp.com/send?phone=628974525222&text=Halo%20kak!%20Saya%20tertarik%20untuk%20konsultasi%20sosial%20media%20manajemen%20di%20Creatifa%20Studio%20%0A%0ANama%20Saya%20%3A%0ABisnis%20Saya%20%3A%0ABergerak%20di%20Bidang%20%3A%0ALokasi%20%3A%0AWebsite%20%2F%20Sosmed%20Bisnis%20Saya%20%3A%0AEmail%20Saya%20%3A"
                  target="_blank"
                  rel="noreferrer"
                  type="button"
                  className="btn btn-red px-4 fs-3 shadow text-decoration-none"
                >
                  Pesan Sekarang!
                </a>
              </div>
            </div>
          </div>
        </div>

        <div data-aos="fade-right">
          <footer className="container-fluid mt-6 overflow-hidden">
            <div className="container mt-5 mb-5 py-3">
              <div className="row col-8 col-sm-4 flex-column">
                <LazyLoad height={200}>
                  <img
                    src="/img/creatifa-logo-with-text.png"
                    className="img-fluid"
                    alt="Logo Creatifa"
                  />
                </LazyLoad>
              </div>

              <h3 className="text-black fw-bold mb-4 fs-4 mt-5">
                Kontak Kami :
              </h3>

              <table className="table table-borderless table-responsive">
                <tbody className="text-black fw-bold fs-5">
                  <tr>
                    <td>Alamat</td>
                    <td>:</td>
                    <td>Kec Pedurungan, Kota Semarang</td>
                  </tr>
                  <tr>
                    <td>Email</td>
                    <td>:</td>
                    <td>cs@creatifastudio.com</td>
                  </tr>
                  <tr>
                    <td>Contact</td>
                    <td>:</td>
                    <td>+62(0) 897 4525 222</td>
                  </tr>
                  <tr>
                    <td colSpan="3">
                      <a
                        href="mailto:cs@creatifastudio.com"
                        className="btn btn-red text-white px-2 py-1 me-3"
                      >
                        <FontAwesomeIcon
                          icon={faEnvelope}
                          className="text-center fa-fw fs-4"
                        />
                      </a>
                      <a
                        href="https://www.instagram.com/creatifastudio/"
                        target="_blank"
                        rel="noreferrer"
                        className="btn btn-red text-white px-2 py-1 me-3"
                      >
                        <FontAwesomeIcon
                          icon={faInstagram}
                          className="text-center fa-fw fs-4"
                        />
                      </a>
                      <a
                        href="https://api.whatsapp.com/send?phone=628974525222&text=Halo%20kak!%20Saya%20tertarik%20untuk%20konsultasi%20sosial%20media%20manajemen%20di%20Creatifa%20Studio%20%0A%0ANama%20Saya%20%3A%0ABisnis%20Saya%20%3A%0ABergerak%20di%20Bidang%20%3A%0ALokasi%20%3A%0AWebsite%20%2F%20Sosmed%20Bisnis%20Saya%20%3A%0AEmail%20Saya%20%3A"
                        target="_blank"
                        rel="noreferrer"
                        className="btn btn-red text-white px-2 py-1 me-3"
                      >
                        <FontAwesomeIcon
                          icon={faWhatsapp}
                          className="text-center fa-fw fs-4"
                        />
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            {this.lazyLoadSetting()}
          </footer>
        </div>
      </div>
    );
  }
}

export default LPSection1;
